<template>
<div class="search" :id="id">
    <div class="search-box">
        <div class="nj-label" v-if="label != ''">{{ label }}</div>
        <div class="nj-search-box" :id="id + '-box'">
            <input type="text" class="nj-search-box-text" v-model="param" @keyup.enter="search()" @keyup="keyup($event)" placeholder="buscar..." :ref="id + '-text'">
            <span class="nj-search-box-remove" @click="remove()" v-if="enableRemove">
                <i class="mdi-delete"></i>
            </span>
            <span class="nj-search-box-close" @click="close()" v-if="enableClose">
                <i class="mdi-close"></i>
            </span>
        </div>
        <div class="nj-result-list" v-if="showResult" :id="id + '-items'" :style="'width: ' + this.position.width" @blur="showResult = false">
            <div class="nj-result-list-item" v-for="item in items" :key="item[itemKey]" @click="select(item)">
                <slot :item="item" v-if="enableSlot"></slot>
                <span v-if="!enableSlot">{{ labelFunction(item) }}</span>
                <i class="mdi mdi-arrow-right-bold"></i>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Keyboard from "../../util/keyboard"
import { Button } from "."
export default {
    name: "InputSearch",
    components: {
        Button
    },
    props: {
        id: {
            type: String
        },
        label: {
            type: String,
            default: ""
        },
        items: {
            type: Array
        },
        itemKey: {
            type: String
        },
        labelFunction: {
            type: Function,
            default: null
        },
        enableSlot: {
            type: Boolean,
            default: false
        },
        selectAndReset: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            param: null,
            showResult: false,
            enableRemove: false,
            enableClose: false,
            position: {
                width: 0,
                top: 0,
                left: 0
            }
        }
    },
    watch: {
        items(newItems) {
            this.showResult = newItems.length != 0
            this.enableClose = newItems.length != 0
        }
    },
    methods: {
        search() {
            this.$emit("search", this.param == "" ? null : this.param)
        },
        select(item) {
            if (this.selectAndReset) {
                this.param = null
                this.showResult = false
                this.enableClose = false
                this.enableRemove = false
                this.$refs[`${this.id}-text`].focus()
            }
            else {
                this.param = this.labelFunction(item)
                this.showResult = false
                this.enableClose = false
                this.enableRemove = true
            }
            this.$emit("select", item)
        },
        remove() {
            this.enableRemove = false
            this.param = null
            this.$emit("remove")
        },
        keyup(event) {
            if ((event.code == "Backspace" || event.code == "Delete") && (this.param == "")) {
                this.remove()
            }
        },
        fix() {
            // [**] revisar si es necesario el metodo fix()
            const input = document.getElementById(this.id + "-box")
            if (input) {
                const data = input.getBoundingClientRect()
                this.position.width = data.width + "px"
                if (this.isResult) {
                    const itemsElement = document.getElementById(this.id + "-items")
                    itemsElement.style.width = this.position.width
                }
            }
        },
        close() {
            this.showResult = false
            this.enableClose = false
        }
    },
    mounted() {
        this.fix()
        window.onresize = () => {
            this.fix()
        }

        Keyboard.escape(() => {
            this.close()
        }, this.id)
    }
}
</script>

<style scoped>
.nj-result-list {
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 400px;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: var(--radius);
    background-color: #fff;
    box-shadow: 0 4px 6px -4px #00000024;
    z-index: 1;
}

.nj-result-close {
    display: flex;
    justify-content: end;
    padding: 6px;
}

.nj-result-list-item {
    display: grid;
    gap: 4;
    grid-template-columns: 1fr auto;
    align-items: center;
    border: 1px solid #ccc;
    border-width: 0 0 1px 0;
    padding: 4px;
    flex: 1 1 auto;
}

.nj-result-list-item:hover {
    background-color: #ffb;
}

.nj-result-list-item>* {
    cursor: pointer;
    padding: 4px;
}

.nj-search-box {
    display: flex;
    align-items: center;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    border-radius: var(--radius);

}

.nj-search-box-text {
    outline: none;
    border: 1px solid transparent;
    border-radius: var(--radius);
    line-height: 18px;
    padding: 3px 6px;
    color: #666;
    font-size: var(--font-size);
    flex-shrink: 1;
    flex-grow: 1;
}

.nj-search-box-close {
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 0;
}

.nj-search-box-close>i {
    cursor: inherit;
    padding: 0 4px;
}

.nj-search-box-remove {
    cursor: pointer;
    flex-shrink: 0;
    flex-grow: 0;
}

.nj-search-box-remove>i {
    cursor: inherit;
    padding: 0 4px;
}
</style>